import { List } from 'immutable';
import { createSelector } from 'reselect';

import { cameraScheduleSelector } from '@sophocles/entities/CameraSchedule';
import { selectImagesByCamera } from '@sophocles/features/media/slice';

export const cameraSelector = state => state.entities.cameras;

export const getCamerasWithSchedules = createSelector(cameraSelector, cameraScheduleSelector, (cameras, schedules) => {
  let newCameras = cameras.map(camera => camera.set('schedules', List()));
  schedules.forEach(schedule => {
    const camera_id = schedule.get('camera', 0) + '';
    const camera = newCameras.get(camera_id, null);
    if (camera != null) {
      const schedules = camera.get('schedules');
      newCameras = newCameras.set(camera_id, camera.set('schedules', schedules.push(schedule)));
    }
  });
  return newCameras;
});

export const getCameraSelector = createSelector(getCamerasWithSchedules, selectImagesByCamera, (cameras, images) =>
  cameras.map(camera => camera.set('images', images.get(camera.get('id', 0) + '', List()))),
);
